import {Box, BoxProps as MUIBoxProps} from '@mui/material';

export interface BoxProps extends MUIBoxProps {}

const Section = (props: BoxProps) => {
  return (
    <Box sx={{marginTop: 12}} {...props}>
      {props.children}
    </Box>
  );
};

export default Section;
